import { connect } from 'react-redux';
import { Action, bindActionCreators, Dispatch } from 'redux';

import { selectServiceRequestDocuments } from 'redux/selectors/request';
import { getServiceRequestDocuments } from 'redux/actions/request';
import { StateType } from 'types';

const mapStateToProps = (state: StateType) => ({
  requestDocuments: selectServiceRequestDocuments(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators({
    getServiceRequestDocuments,
  }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps);
